import { render, staticRenderFns } from "./MentionMenuPopover.vue?vue&type=template&id=0f2692c2&"
import script from "./MentionMenuPopover.vue?vue&type=script&lang=ts&"
export * from "./MentionMenuPopover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports